<div class="checkbox-inline">
    <label class="checkbox checkbox-solid">
        <input type="checkbox" [(ngModel)]="checked" value="true">
        <span></span>
    </label>
</div>